<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="left ">First Mariner Books edition 2017</p>
<p class="left ">Copyright © 2016 by Peter Ho Davies</p>
<p class="left ">Reading Group Guide copyright © 2017 by Houghton Mifflin Harcourt Publishing Company</p>
<p class="left ">Q&amp;A with Author copyright © 2017 by Peter Ho Davies</p>
<div class="timebreak "> </div>
<p class="left ">All rights reserved</p>
<div class="timebreak "> </div>
<p class="left ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="left "><a href="http://www.hmhco.com/Popular-reading" target="_blank">www.hmhco.com</a></p>
<div class="timebreak "> </div>
<p class="left "><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="left ">Names: Davies, Peter Ho, date, author.</p>
<p class="left ">Title: The fortunes / Peter Ho Davies.</p>
<p class="left ">Description: Boston ; New York : Houghton Mifflin Harcourt, 2016.</p>
<p class="left ">Identifiers: <span class="smallcaps">LCCN</span> 2016005161 (print) | <span class="smallcaps">LCCN</span> 2016011840 (ebook) | <span class="smallcaps">ISBN</span> 9780544263703 (hardback) | <span class="smallcaps">ISBN</span> 9780544263789 (ebook) | <span class="smallcaps">ISBN</span> 9781328745484 (pbk)</p>
<p class="left ">Subjects: | <span class="smallcaps">BISAC: FICTION</span> / Literary. | <span class="smallcaps">FICTION</span> / General.</p>
<p class="left ">Classification: <span class="smallcaps">LCC</span> <span class="smallcaps">PR</span>6054.<span class="smallcaps">A</span>89145 <span class="smallcaps">T</span>45 2016 (print) | <span class="smallcaps">LCC</span> <span class="smallcaps">PR</span>6054.<span class="smallcaps">A</span>89145 (ebook) | <span class="smallcaps">DDC</span> 823/.914—dc23</p>
<p class="left "><span class="smallcaps">LC</span> record available at <a href="http://lccn.loc.gov/2016005161" target="_blank">http://lccn.loc.gov/2016005161</a></p>
<div class="timebreak "> </div>
<p class="left ">Cover design by Brian Moore</p>
<p class="left ">Hand lettering by Joel Holland</p>
<div class="timebreak "> </div>
<p class="left ">v3.1120</p>
<div class="timebreak "> </div>
<p class="left ">“Kung Fu Fighting,” written by Carlton Douglas, © Edition Carren. All rights reserved. Used by permission.</p>
<div class="timebreak "> </div>
<p class="left ">“Half-Caste Woman,” words and music by Noël Coward, copyright © 1931 (renewed) WB Music Corp. All rights reserved. Used by permission of Alfred Music.</p>
<div class="timebreak "> </div>
<p class="left ">“These Foolish Things,” words by Holt Marvell, music by Jack Strachey. Copyright © 1936 (renewed) by Boosey &amp; Co. Ltd. All rights for the U.S.A. and Canada controlled by Bourne Co. All rights reserved. International copyright secured. ASCAP.</p>
<div class="timebreak "> </div>
<p class="left ">Oriental riff illustration on <a href="#/front03#px3">page vii</a>: © 2016 Houghton Mifflin Harcourt Publishing Company.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?4b978da4